import React, { useEffect, useRef, useState } from "react";
import { Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { LoginApi } from "../../api/request/users";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import Message from "../../assets/auth/Message.jsx";
import Lock from "../../assets/auth/Lock.jsx";
import { cleareCookies, setCookies } from "../../services/Cookies.jsx";
import { useDispatch } from "react-redux";
import { setloggedIn, setUserDetails } from "../../store/Slices/userSlice.js";
import { IpProvider } from "../../services/IpProvider.js";
import { handleApiError } from "../../utils/handleApiError.js";
import { useResponsive } from "../../hooks/useResponsive.js";
import { getPostLoginPath, enrichUserWithAccountType } from "../../utils/onboarding.js";

function Login() {
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ email: "", password: "", });
  const [ipAddress, setIpAddress] = useState('');

  const getIpAddress = async () => {
    try {
      const { data } = await IpProvider();
      setIpAddress(data?.ip);
    } catch (error) { }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;
    if (!email || !password) {
      toast.error("Email or password can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        ...formData,
        platformName: "user",
        ipAddress: ipAddress,
        domain: 'upforex.live'
      };
      cleareCookies();
      const { data } = await LoginApi(params);
      if (data?.success) {
        toast.success(data?.message);
        if (data?.data?.verifyWithOpt) {
          localStorage.setItem("userId", data?.data?.userId);
          navigate("/otp");
        } else {
          setCookies('token', data?.data?.access_token);
          let user = { ...data?.data };
          delete user?.access_token;
          user = await enrichUserWithAccountType(user);
          dispatch(setUserDetails(user));
          dispatch(setloggedIn(true));
          localStorage.clear('userId');
          navigate(getPostLoginPath(user));
        }
      }
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getIpAddress();
  }, []);

  return (
    <>
      {!isMobile ? <div className="auth-page">
        <form autoComplete="off" onSubmit={handleSubmit}>
          <div className="w-full text-sm py-1">
            <p className="text-[#585F70] font-semibold ">Email</p>
            <div className="relative">
              <Form.Item type="email" name="emailId">
                <Input
                  placeholder="Enter your email-id"
                  className="border rounded-lg w-full ps-3 py-2"
                  prefix={<Message />}
                  onChange={handleChange}
                  name="email"
                  value={formData.email}
                  defaultValue={formData.email}
                />
              </Form.Item>
            </div>
          </div>
          <div className="w-full text-sm font-normal py-1 mt-3">
            <p className="text-[#585F70] font-semibold">Password</p>
            <div div className="relative">
              <Form.Item name="password">
                <Input.Password
                  placeholder="Enter your password"
                  className="border rounded-lg w-full ps-3 py-2"
                  prefix={<Lock />}
                  name="password"
                  onChange={handleChange}
                  value={formData.password}
                  defaultValue={formData.password}
                />
              </Form.Item>
            </div>
          </div>
          <div className="flex justify-end w-full text-sm font-normal">
            <Link
              to="/forget_password"
              className="font-semibold text-xs primary cursor-pointer"
            >
              Forgot Password?
            </Link>
          </div>
          <div className="mt-5">
            <LoadableButton
              type="submit"
              className="bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text"
              lable="Login"
              isLoading={isLoading}
              loadingLable="Loging in..."
            />
          </div>
          <div className="text-center text-sm mt-4">
            <p>Don't have an account? <Link to="?tab=register" className="primary underline">sign up</Link></p>
          </div>
        </form>
      </div>
        : <div className="">
          <div className="my-5 mt-10">
            <p className="text-xl font-bold mb-2 text-dark-200">Login</p>
            <p className="text-gray-500">Welcome, Please Enter your Credentials to access your Account</p>
          </div>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="w-full text-sm py-1">
              <div className="relative">
                <Form.Item type="email" name="emailId">
                  <Input
                    placeholder="Email-id"
                    className="border border-slate-200 rounded-[14px] w-full ps-3 py-3"
                    // prefix={<Message />}
                    onChange={handleChange}
                    name="email"
                    value={formData.email}
                    defaultValue={formData.email}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="w-full text-sm font-normal py-1 mt-3">
              <div div className="relative">
                <Form.Item name="password">
                  <Input.Password
                    placeholder="Password"
                    className="border border-slate-200 rounded-[14px] w-full ps-3 py-3"
                    // prefix={<Lock />}
                    name="password"
                    onChange={handleChange}
                    value={formData.password}
                    defaultValue={formData.password}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-end w-full text-sm font-normal">
              <Link
                to="/forget_password"
                className="font-semibold text-xs primary cursor-pointer"
              >
                Forgot Password?
              </Link>
            </div>
            <div className="mt-5">
              <LoadableButton
                type="submit"
                className="bg-primary text-[#FFFFFF] font-semibold text-lg rounded-[14px] w-full py-3 text"
                lable="Login"
                isLoading={isLoading}
                loadingLable="Loging in..."
              />
            </div>
            <div className="text-center text-sm mt-4">
              <p>Don't have an account? <Link to=
                "?tab=register" className="primary underline">Sign Up</Link></p>
            </div>
          </form>
        </div>}
    </>
  );
}
export default Login;
